import React from 'react'
import d3 from 'd3'
import equal from 'deep-equal'

import utils from '../utils'

export default React.createClass({
  propTypes: {
    settings: React.PropTypes.object.isRequired,
    x: React.PropTypes.number.isRequired,
    y: React.PropTypes.number.isRequired,
    width: React.PropTypes.number.isRequired,
    height: React.PropTypes.number.isRequired,
    maxCol: React.PropTypes.number,
    maxRow: React.PropTypes.number,
    onRedraw: React.PropTypes.func
  },
  shouldComponentUpdate(nextProps) {
    let update =  !equal(nextProps.settings, this.props.settings) ||
                  nextProps.x !== this.props.x ||
                  nextProps.y !== this.props.y ||
                  nextProps.width !== this.props.width ||
                  nextProps.height !== this.props.height;
    
    if (!update && nextProps.data.length !== this.props.data.length ||
       (this.props.data.length !=0 && nextProps.data[nextProps.data.length-1].id != this.props.data[this.props.data.length-1].id))
      this.draw();

    return update;
  },
  componentDidUpdate() {
    if(!this._layer)
      this._layer = d3.select(this.refs.layer);

    this.redraw();
  },
  render() {
    let style = this.getStyle();
    let attr = {
      transform: `translate(${this.props.x}, ${this.props.y})`
    };

    return (
      <g ref="layer" className="layer" style={style.pattern} {...attr} >
        <rect style={style.layer} width={this.props.width} height={this.props.height} />
      </g>
    )
  },
  getStyle() {
    let {pattern, contrast} = this.props.settings;
    let {color1, color2} = contrast;
    let stroke;
    let fill;
    let background;

    // see through
    if (contrast.type === 0) {
      stroke = color1;
      fill = 'transparent';
      background = color2;
    }
    // bicolor
    else if (contrast.type === 1) {
      stroke = color1;
      fill = color2;
      background = color2;
    }
    // unicolor
    else if (contrast.type === 2) {
      stroke = color1;
      fill = color1;
      background = color2;
    }

    return {
      pattern: {
        fill: fill,
        stroke: stroke,
        strokeWidth: pattern.border,
        strokeLinecap: 'round'
      },
      layer: {
        fill: background,
        strokeWidth: 0
      }
    }
  },
  draw() {
    // limit data points to fit artboard bounds
    let data = this.props.data.slice(0, this._maxIndex + 1);

    // data join
    let patterns = this._layer.selectAll('.pattern')
      .data(data, function(d) { return d.id });

    // add new patterns
    let entering = patterns.enter().append('g')
      .classed('pattern', true);

    // set pattern flow
    this.setFlow(entering);

    // add pattern
    this.addPattern(entering);

    // remove old elements
    let exiting = patterns.exit();
    exiting.remove();
  },
  redraw() {
    // remove all patterns
    this._layer.selectAll('.pattern').remove();

    // extract settings
    let {pattern, layout} = this.props.settings;

    // calulate maximum grid size
    this._col = layout.maxCol || Math.floor(this.props.width / layout.spaceX);
    this._row = layout.maxRow || Math.floor(this.props.height / layout.spaceY);
    this._maxIndex = this._col * this._row - 1;

    // calculate offset for centering
    this._layerWidth = layout.spaceX * (this._col - 1) + pattern.size;
    this._layerHeight = layout.spaceY * (this._row - 1) + pattern.size;
    this._xOffset = this.props.width / 2 - this._layerWidth / 2;
    this._yOffset = this.props.height /2 - this._layerHeight / 2;

    // redraw all patterns
    this.draw();

    // send redraw information upstream
    if (this.props.onRedraw)
      this.props.onRedraw({
        maxIndex: this._maxIndex,
        col: this._col,
        row: this._row
      });
  },
  setFlow(g) {
    let _this = this;
    let {layout} = this.props.settings;

    // page horizontal
    if (layout.type === 0) {
      g.attr('transform', function(d, i) {
        let xPos = i % _this._col;
        let yPos = Math.floor(i / _this._col);
        return _this.getTranslation(xPos, yPos, d);
      });
    }

    // page vertical
    else if (layout.type === 1) {
      g.attr('transform', function(d, i) {
        let xPos = Math.floor(i / _this._row);
        let yPos = i % _this._row;
        return _this.getTranslation(xPos, yPos, d);
      });
    }

    // snake horizontal
    else if (layout.type === 2) {
      g.attr('transform', function(d, i) {
        let yPos = Math.floor(i / _this._col);
        let xPos = yPos % 2 === 0 ?
          i % _this._col :
          _this._col - (i % _this._col) - 1;
          return _this.getTranslation(xPos, yPos, d);
      });
    }

    // snake vertical
    else if (layout.type === 3) {
      g.attr('transform', function(d, i) {
        let xPos = Math.floor(i / _this._row);
        let yPos = xPos % 2 === 0 ?
          i % _this._row :
          _this._row - (i % _this._row) - 1;
          return _this.getTranslation(xPos, yPos, d);
      });
    }

    // spiral inward
    else if (layout.type === 4) {
      g.attr('transform', function(d, i) {
        let pos = utils.spiral(i, _this._col, _this._row);
        let xPos = pos.x;
        let yPos = pos.y;
        return _this.getTranslation(xPos, yPos, d);
      });
    }

    // spiral outward
    else if (layout.type === 5) {
      g.attr('transform', function(d, i) {
        let pos = utils.spiral(_this._maxIndex - i, _this._col, _this._row);
        let xPos = pos.x;
        let yPos = pos.y;
        return _this.getTranslation(xPos, yPos, d);
      });
    }
  },
  addPattern(g) {
    let {pattern} = this.props.settings;

    // square pattern
    if (pattern.type === 0) {
      let x = function(d) { return pattern.size / 2 - pattern.size * d.scaleX / 2 };
      let y = function(d) { return pattern.size / 2 - pattern.size * d.scaleX / 2 };
      let width = function(d) { return pattern.size * d.scaleX };
      let height = function(d) { return pattern.size * d.scaleX };

      g.append('rect').attr({ x: x, y: y, width: width, height: height });
    }

    // circle pattern
    else if (pattern.type === 1) {
      let cx = d => { return pattern.size / 2 };
      let cy = d => { return pattern.size / 2 };
      let rx = d => { return pattern.size * d.scaleX / 2 };
      let ry = d => { return pattern.size * d.scaleX / 2 };

      g.append('ellipse').attr({ cx: cx, cy:cy, rx: rx, ry: ry });
    }

    // cross pattern
    else if (pattern.type === 2) {
      let x1 = d => { return d3.interpolate(pattern.size / 2, 0)(d.scaleX) };
      let y1 = d => { return d3.interpolate(pattern.size / 2, 0)(d.scaleX); };
      let x2 = d => { return d3.interpolate(pattern.size / 2, pattern.size)(d.scaleX) };
      let y2 = d => { return d3.interpolate(pattern.size / 2, pattern.size)(d.scaleX); };
      
      g.append('line').attr({ x1: x1, y1: y1, x2: x2, y2: y2 });
      g.append('line').attr({ x1: x1, y1: y2, x2: x2, y2: y1 });
    }

    // diamond pattern
    else if (pattern.type === 3) {
      let half = pattern.size / 2;
      let points = d => {
        let xOffset = pattern.size / 4 * d.scaleX;
        let yOffset = half * d.scaleX;

        return [
          // top
          half, half - yOffset,
          // right
          half + xOffset, half,
          // bottom
          half, half + yOffset,
          // left
          half - xOffset, half
        ].join(' ')
      };

      g.append('polygon').attr({ points: points });
    }

    // hexagon pattern
    else if (pattern.type === 4) {
      let half = pattern.size / 2;

      // configure polygon
      let sides = 6;
      let startAngle = 0;

      let points = d => {
        // only scaleX can apply
        let r = pattern.size / 2 * d.scaleX;
        return utils.getPolygon(half, half, r, sides, startAngle).join(' ');
      }

      g.append('polygon').attr({ points: points });
    }
  },
  getTranslation(xPos, yPos, d) {
    let {layout} = this.props.settings;

    // translate normalized grid position
    let x = xPos * layout.spaceX;
    let y = yPos * layout.spaceY;
    let translate = `translate(${x + this._xOffset}, ${y + this._yOffset})`;

    return translate;
  }
})



/** WEBPACK FOOTER **
 ** ./src/components/Layer.js
 **/